import { THROTTLE_TIMEOUT } from '../../config';

export function throttle(
	callback: () => void,
	delay: number = THROTTLE_TIMEOUT
) {
	let timeoutHandler: ReturnType<typeof setTimeout> | null = null;
	return () => {
		if (timeoutHandler == null) {
			timeoutHandler = setTimeout(() => {
				callback();
				timeoutHandler = null;
			}, delay);
		}
	};
}
